package com.example.mystybag.appCore.logic

import com.example.mystybag.appCore.logic.pages.LanguageSelectionBottomSheetViewModel
import com.example.mystybag.core.logic.base.BottomSheetChild

class LanguageSelectionBottomSheetChild(
    override val viewModel: LanguageSelectionBottomSheetViewModel
) : BottomSheetChild(viewModel = viewModel)
